import React from "react";
import { Typography } from "@/components/Typography";
import { PreviewCloudinaryImage } from "@/features/previews/shared";
import { LOGO_VARIANTS, SPACING, TYPOGRAPHY_CLASSES } from "../constants";

interface BusinessHeaderVariantProps {
  logoUrl?: string;
  title?: string;
  companyName?: string;
  isInitialPreview?: boolean;
  logoAlt?: string;
}

export const BusinessHeaderVariant = ({
  logoUrl,
  title,
  companyName,
  isInitialPreview,
  logoAlt,
}: BusinessHeaderVariantProps) => {
  return (
    <>
      {companyName && (
        <div className="preview-hero-header__company-name">
          <Typography
            Tag="p"
            classname={TYPOGRAPHY_CLASSES.SEMIBOLD}
          >
            {companyName}
          </Typography>
        </div>
      )}

      <div className="preview-hero-header__main">
        {logoUrl && (
          <div className="preview-hero-header__logo-container">
            <PreviewCloudinaryImage
              src={logoUrl}
              alt={logoAlt || companyName || title || "Business logo"}
              className="preview-hero-header__logo"
              placeholderClass="preview-hero-header__logo"
              variant={LOGO_VARIANTS.HERO}
              isInitPreview={isInitialPreview}
            />
          </div>
        )}

        {title && (
          <div
            className={`preview-hero-header__title ${
              logoUrl ? "preview-hero-header__title--with-logo" : ""
            }`}
          >
            <Typography
              Tag="p"
              size="l"
              classname={`${TYPOGRAPHY_CLASSES.SEMIBOLD} ${SPACING.MEDIUM}`}
            >
              {title}
            </Typography>
          </div>
        )}
      </div>
    </>
  );
};
